var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("Are they adherent to their current treatment?")])}
var staticRenderFns = []

export { render, staticRenderFns }